import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary capturou um erro:', error, info);
  }

  render() {
    const { hasError } = this.state;
    if (hasError) {
      return (
        <div className="alert alert-danger" role="alert">
          Ocorreu um erro ao exibir esta seção. Tente recarregar a página.
        </div>
      );
    }
    const { children } = this.props;
    return children;
  }
}

export default ErrorBoundary;
